import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '../form/floating_label/select';
import { showFiltersAction } from '../../actions/catalog_filter_view_actions';
import { CatalogMobileFiltersGoogleAnalytics } from '../../../_modules/google_analytics/catalog/mobile_filters';
import { showMobileFiltersAction } from '../../actions/catalog_mobile_filter_visibility_actions';
import Translation from '../translation/translation';
import { FilterSections } from '../../constants/filter/filter_sections';
import { Filters } from '../../constants/filter/filters';
import { Brand } from '../catalog_filters/filters_column/filter_sections/brand';
import { FilterSelect } from '../catalog_filters/filters_column/filter_sections/filters/filter_select';
import { FilterCheckbox } from '../catalog_filters/filters_column/filter_sections/filters/filter_checkbox';
import { getDefaultValueForFilter } from '../../helper/filters/get_default_value_for_filter';
import getTranslatedText from '../../helper/get_translated_text';

function CatalogFilters(props) {
  const {
    sorting,
    sortingOptions,
    onSortingChange,
    conditionalFilters,
    filterValues,
    filterOptions,
    onToolTipHover,
    onChangeCallback,
  } = props;

  const onOpenFiltersClick = () => {
    if ($(window).width() >= 768) {
      showFiltersAction();
    } else {
      CatalogMobileFiltersGoogleAnalytics.openMobileFilters();
      showMobileFiltersAction();
    }
  };

  return (
    <>
      <div className="catalog-filters-statusbar justify-content-space-between">
        <div className="display-flex primary-filters">
          <PrimaryFilters
            conditionalFilters={conditionalFilters}
            filterValues={filterValues}
            filterOptions={filterOptions}
            onToolTipHover={onToolTipHover}
            onChangeCallback={onChangeCallback}
          />
        </div>

        <div className="display-flex">
          <MoreFilters onClickMoreFilters={onOpenFiltersClick} />
          <SortByFilter sorting={sorting} sortingOptions={sortingOptions} onSortingChange={onSortingChange} />
        </div>
      </div>
    </>
  );
}

function PrimaryFilters({
  conditionalFilters,
  filterValues,
  filterOptions,
  onToolTipHover,
  onChangeCallback,
}) {
  return (
    <>
      <div className="display-flex catalog-filter-sort">
        <FilterSelect
          name={Filters.MANUFACTURER}
          value={filterValues[Filters.MANUFACTURER]}
          options={filterOptions[Filters.MANUFACTURER]}
          labelTranslationKey="catalog-filter-brand-label"
          provideAllTranslationKey="catalog-filters-manufacturer-select-label-all"
          onChange={onChangeCallback}
          provideAllOption={true}
          showTooltip={false}
          highlight={!filterValues[Filters.MANUFACTURER]}
        />
      </div>

      <div className='catalog-filter-checkbox'>
        <FilterCheckbox
          name={Filters.RUN_FLAT}
          checked={getDefaultValueForFilter(Filters.RUN_FLAT) !== filterValues[Filters.RUN_FLAT]}
          labelTranslationKey={'catalog-primary-filters-runflat-label'}
          tooltipContent={
            conditionalFilters[Filters.RUN_FLAT]
              ? getTranslatedText('catalog-filters-rft-tooltip')
              : getTranslatedText('catalog-filters-conditional-option-disabled')
          }
          onChange={onChangeCallback}
          onToolTipHover={onToolTipHover}
          disabled={!conditionalFilters[Filters.RUN_FLAT]}
        />
      </div>
    </>
  );
}

function SortByFilter({ sorting, sortingOptions, onSortingChange }) {
  return (
    <div className="display-flex catalog-filter-sort">
      <Translation
        translationKey="catalog-sorting-headline-mobile"
        className="catalog-filter-sort-label"
        tagName="div"
      />

      <Select
        value={sorting}
        hasValue={!!sorting}
        options={sortingOptions}
        label=""
        name="sorting"
        onChange={onSortingChange}
        additionalClassNames={['catalog__sorting-select']}
      />
    </div>
  );
}

function MoreFilters(props) {
  return (
    <div className="display-flex catalog-filter-more-filter" onClick={props.onClickMoreFilters}>
      <Translation
        translationKey="catalog-more-filter-label"
        className="hidden-xs"
        style={{ marginRight: '10px' }}
        tagName="span"
      />

      <Translation
        translationKey="catalog-filter-results-label-mobile"
        className="visible-xs"
        style={{ marginRight: '10px' }}
        tagName="span"
      />

      <img
        src={TYROOLA.globals.staticImagesUrl + 'images/catalog/statusbar/more-filter-icon.svg'}
        alt="more-filter-icon"
        width={16}
        height={16}
      />
    </div>
  );
}

export { CatalogFilters };
